export enum EnvironmentName {
  DEV = 'dev',
  LOCAL = 'local',
  STAGE = 'stage',
  PROD = 'prod',
}

export interface Environment {
  name: EnvironmentName;
  apiUrl: string;
  socketUrl: string;
}
